export default "__VITE_ASSET__BIlfk9Ci__"